import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import * as permissionKind from '../../../../shared/permissions';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import { useCompany } from '../../../components/contexts/CompanyContextManager';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import hasPermissions from '../../../utilities/hasPermissions';
import useGoTo from '../../../utilities/useGoTo';
import UserList from './UserList';

const UserListPage = () => {
    const { t } = useTranslation('userList');
    const { permissions: accountPermissions } = useAccount();
    const goToNewUserPage = useGoTo('/admin/accesses/users/add');
    const company = useCompany(true);

    const hasPermission = company
        ? hasPermissions(company.permissions, [permissionKind.createUser]) &&
          hasPermissions(accountPermissions, [permissionKind.createUser])
        : hasPermissions(accountPermissions, [permissionKind.createUser]);

    const extra = hasPermission ? (
        <Button icon={<PlusOutlined />} onClick={goToNewUserPage} type="primary">
            {t('userList:actions.newUser')}
        </Button>
    ) : null;

    return (
        <ConsolePageWithHeader extra={extra} title={t('userList:title')}>
            <UserList />
        </ConsolePageWithHeader>
    );
};

export default UserListPage;
